"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./listview.css");
var ListView = function (props) {
    var _a = props.list, list = _a === void 0 ? [] : _a, heading = props.heading, pageUrl = props.pageUrl;
    var handleClickEvent = function (targetUrl) {
        return function () { return window.open(targetUrl); };
    };
    return (react_1.default.createElement("div", { className: "listview-outer-container" },
        heading && react_1.default.createElement("div", { className: "heading" }, heading),
        react_1.default.createElement("div", { className: "listview-container" },
            react_1.default.createElement("ul", null, list.map(function (thread) { return (react_1.default.createElement("li", { key: thread.title },
                react_1.default.createElement("div", { className: "listview-item", onClick: handleClickEvent(thread.thread_url) },
                    react_1.default.createElement("figure", { className: "thread-image" },
                        react_1.default.createElement("img", { src: thread.theme_image ||
                                (thread.metadata && thread.metadata.image) ||
                                "https://designshack.net/wp-content/uploads/placeholder-image.png", alt: "" })),
                    react_1.default.createElement("section", null,
                        react_1.default.createElement("div", { className: "title" }, thread.title),
                        thread.user && (react_1.default.createElement("div", { className: "user-info" },
                            react_1.default.createElement("div", { className: "user-image" }, thread.user.image_url ? (react_1.default.createElement("img", { className: "profile-image", src: thread.user.image_url, alt: "" })) : (react_1.default.createElement("div", { className: "no-profile-image" }, "\u00A0"))),
                            react_1.default.createElement("div", { className: "user-name" }, thread.user.name))),
                        thread.note && react_1.default.createElement("div", { className: "note" }, thread.note))))); }))),
        pageUrl && (react_1.default.createElement("div", { className: "show-more", onClick: handleClickEvent(pageUrl) }, "Show more stories"))));
};
exports.default = ListView;
